import { deptTreeOrdered } from "../utils";

// Opciones <option> de departamentos ORDENADAS y ANIDADAS por jerarquía, con
// sangría por nivel. Úsalo DENTRO de un <select> en lugar de
// `departments.map(d => <option>…)` para que TODOS los desplegables de
// departamento se vean igual (pedido 2026-10-08).
//
// Props:
//   departments        lista (useMeta().departments o la del alcance)
//   all / allLabel     agrega "Todos" (value "") al tope      [filtros]
//   none / noneLabel   agrega "Sin departamento / No asignado" [filtros y formularios]
//   noneValue          value de la opción "No asignado" (filtros: "none"; formularios: "")
const SANGRIA = "    ";   // 4 espacios duros por nivel

export default function DeptOptions({
  departments = [], all = false, allLabel = "Todos",
  none = false, noneLabel = "No asignado", noneValue = "none",
}) {
  const filas = deptTreeOrdered(departments);
  return (
    <>
      {all && <option value="">{allLabel}</option>}
      {none && <option value={noneValue}>{noneLabel}</option>}
      {filas.map((d) => (
        <option key={d.id} value={d.id}>
          {`${SANGRIA.repeat(d.depth)}${d.depth ? "└ " : ""}${d.name}`}
        </option>
      ))}
    </>
  );
}

// Etiqueta de un departamento por id, para MOSTRAR en listas/tablas. Si el id es
// vacío/null o no existe en la lista, devuelve "No asignado".
export function deptLabel(departments, id, noneLabel = "No asignado") {
  if (!id) return noneLabel;
  const d = (departments || []).find((x) => Number(x.id) === Number(id));
  return d ? d.name : noneLabel;
}
